import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { useEffect, useState } from "react";
import { useAuth } from "../../Context/AuthContext";
import Loader from "../Global/Loader";
import { toNumber } from "lodash";

function Sidebar(props) {
  const {
    loading,
    sidebar,
    unitCount,
    buildingCount,
    activeBar,
    setActivebar,
  } = useAuth();

  useEffect(() => {
    if (props.isSidebarOpen) {
    }
  }, [props.isSidebarOpen]);

  const setSidebarActive = (e, value) => {
    e.preventDefault();
    localStorage.setItem("sidebarActive", value);
    setActivebar(value);
  };

  useEffect(() => {
    const activebar = localStorage.getItem("sidebarActive");
    let Sidebarvalue = activebar;
    if (Sidebarvalue == null) {
      setActivebar();
    } else {
      setActivebar(toNumber(Sidebarvalue));
    }
  }, []);

  const [toggleSecondBar, settoggleSecondBar] = useState(false)
  return (
    <>
      {loading && <Loader />}
      {sidebar?.length > 0 ? (
        <div
          className={
            props.isSidebarOpen ? "sidebar_musk " : "sidebar_musk h-100 w-0"
          }
        >
          <section className="sidebar d-flex flex-column justfy-content-between position-relative overflow-auto">
            <Accordion defaultActiveKey={activeBar} className="mb-1">
              {sidebar?.map((val, i) => {
                return (
                  <Accordion.Item key={i} eventKey={i}>
                    <Accordion.Header title={val.title} onClick={(e) => setSidebarActive(e, i)}>
                      {val.titleIcon}
                      {val.title.slice(0, 15)}{val.title.length > 16 && "..."}
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        {val.children?.map((child, index) => {
                          return (
                            // <div key={index}>
                            <>
                              {(child.to == "AddTenant" && unitCount == 0) ||
                                (child.to == "addmanager" &&
                                  buildingCount == 0) ? null : (
                                <li onClick={() => settoggleSecondBar(!toggleSecondBar)} key={index}>

                                  {
                                    child.children ?

                                      <Link to="" >{child.title}
                                        {toggleSecondBar && <Accordion defaultActiveKey={activeBar} className="mb-1">
                                          <Accordion.Body>
                                            <ul >
                                              {child?.children?.map(ch =>
                                                <li>
                                                  <Link to={`/${ch.to}`}>{ch.title}</Link>
                                                </li>)}
                                            </ul>
                                          </Accordion.Body>
                                        </Accordion>}
                                      </Link>
                                      :

                                      <Link to={`/${child.to}`}>{child.title}
                                        {toggleSecondBar && <Accordion defaultActiveKey={activeBar} className="mb-1">
                                          <Accordion.Body>
                                            <ul >
                                              {child?.children?.map(ch =>
                                                <li>
                                                  <Link to={`/${ch.to}`}>{ch.title}</Link>
                                                </li>)}
                                            </ul>
                                          </Accordion.Body>
                                        </Accordion>}
                                      </Link>
                                  }
                                </li>

                              )}
                            </>
                          );
                        })}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </section>
        </div>
      ) : null}
    </>
  );
}

export default Sidebar;
